import React, {
  useState,
  useContext,
  forwardRef,
  useImperativeHandle,
} from "react";
import { Image } from "@mantine/core";
import { UserContext } from "@/contexts/UserContext/UserContext";
import { notifications } from "@mantine/notifications";
import { Text } from "@/components/Generics/Text";
import { Validatable } from "@/pages/study/StudyStepper";
import { useFetchVesselTypes } from "@/hooks/apiHooks/useFetchVesselTypes";
import { usePageTransition } from "@/hooks/helperHooks/usePageTransition";
import { vesselImageUrls } from "@/data/vesselImageUrls";
import styles from "../../css/ship.module.css";
import { useAppColors } from "@/hooks/contextHooks/useAppColors";

const VesselTypeSelection = forwardRef<Validatable, {}>((props, ref) => {
  // HOOK for Smooth transitions between pages
  const transition = usePageTransition();
  const { colors, isDarkMode } = useAppColors();

  const [selectedVesselType, setSelectedVesselType] = useState<string | null>(
    null,
  );
  const context = useContext(UserContext);

  const { data: vesselTypes, isLoading: isLoadingVesselTypes } =
    useFetchVesselTypes();

  const handleSelect = (type: string) => {
    setSelectedVesselType(type);
    context?.setFormValues((prev) => ({ ...prev, vesselType: type }));
  };

  const validate = () => {
    if (!selectedVesselType) {
      notifications.show({
        title: "Validation Error",
        message: "Please select a vessel type.",
        color: "red",
        autoClose: 4000,
        position: "top-center",
      });
      return false;
    }
    return true;
  };

  useImperativeHandle(ref, () => ({
    validate,
  }));

  if (isLoadingVesselTypes || transition) return null;

  return (
    <div
      className={styles.stepContainer}
      style={{
        width: "100%",
      }}
    >
      <div className={styles.flexContainer}>
        {vesselTypes?.map((type) => (
          <div
            style={{ backgroundColor: colors.gray, borderColor: colors.border }}
            className={styles.card}
            onClick={() => handleSelect(type.vessel_type)}
          >
            <div>
              <Image
                src={vesselImageUrls[type.vessel_type]}
                alt={type.vessel_type}
                height={160}
                style={{ borderRadius: 5 }}
                className={styles.img}
              />
            </div>
            <Text color={colors.secondary}>{type.vessel_type}</Text>
            <div
              onClick={() => handleSelect(type.vessel_type)}
              style={{
                backgroundColor:
                  selectedVesselType === type.vessel_type
                    ? "green"
                    : isDarkMode
                      ? colors.secondary
                      : colors.brand,
                color:
                  selectedVesselType === type.vessel_type
                    ? isDarkMode
                      ? colors.secondary
                      : colors.primary
                    : colors.primary,
                fontSize: "1.2rem",
                width: "15rem",
              }}
              className={styles.selectBtn}
            >
              {selectedVesselType === type.vessel_type
                ? "Selected"
                : "Select Vessel Type"}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});

export default VesselTypeSelection;
